<template>
    <drop-pane-button :icon="['fas', 'paperclip']" panename="messageEditor.attachments"
            ref="button" :tabindex="tabindex"
            class="editbutton" :class="{empty: !attachments.length, isActive: attachments.length}"
            :disabled="disabled" @hide="doHide" :panetabindex="-1"
            :triggerHide="managedTriggerHide">
        <div class="wrap2">
            <input type="file" ref="addLinkInput" :id="$id('file')" @change="processAttachment"
                    style="display: none">
            <div class="input">
                <div class="file">
                    <label class="fileLabel" :for="$id('file')" tabindex="0"
                            @focus="onFileFocus"
                            @click="onFileClick"
                            @keydown="onLabelKeys">{{fileInputLabel
                        }}</label>
                </div>
            </div>

            <div class="preview">
                <div v-for="(a, ind) in attachments" :key="ind" class="attachmentRow"
                        :class="{ selected: ind===selected }" @mouseover="selected=ind">
                    <div class="icon"><font-awesome-icon :icon="getIcon(a)"/></div>
                    <div class="name">{{a.filename}}</div>
                    <div class="size">{{$t('attachmentEditor.size', {size: a.data.length * 3 / 4 })}}</div>
                    <div class="delete" @click="$emit('delete', a.filename)">
                        <font-awesome-icon icon="file-minus"></font-awesome-icon>
                    </div>
                </div>
            </div>
        </div>
    </drop-pane-button>

</template>

<script>
import DropPaneButton from '@/components/dropPaneButton';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import MimeTypes from '@/helpers/MimeTypes';

export default {
  name: 'attachmentsEditor',
  components: { DropPaneButton, FontAwesomeIcon },
  data() {
    return {
      selected: 0,
      disableTriggerHide: false
    };
  },
  props: {
    size: {
      type: String,
      default: '1x'
    },
    attachments: Array,
    disabled: Boolean,
    triggerHide: Boolean,
    tabindex: {
      Type: [ Number, String ],
      default: 0
    }
  },
  methods: {
    onLabelKeys(evt) {
      console.log('key');
      if ((evt.key === ' ') || (evt.key === 'Enter')) {
        console.log('do click');
        this.$refs.addLinkInput.click();
      }
    },
    doAddAttachment() {
    },
    show() {
      this.$refs.button.show();
    },
    doHide() {
    },
    getIcon(a) {
      const mimeType = a.data.split(';')[0].substr(5);
      return MimeTypes.getIcon(mimeType);
    },
    processAttachment(event) {
      console.log('processAttachment', event);
      const fileToLoad = event.target.files[0];

      const reader = new FileReader();
      reader.onload = event => {
        this.attachSrc = event.target.result;
        console.log('got Attachment', event);
        let name = fileToLoad.name;
        let duplicate;
        let counter = 1;
        do {
          console.log(`check ${name} for duplicates`);
          duplicate = false;
          for (const a of this.attachments) {
            console.log(a, name);
            if (a.filename.toUpperCase() === name.toUpperCase()) {
              duplicate = true;
              const i = fileToLoad.name.lastIndexOf('.');
              if (i === -1) {
                name = `${fileToLoad.name} (${counter++})`;
              } else {
                name = `${fileToLoad.name.substr(0, i)} (${counter++})${fileToLoad.name.substr(i)}`;
              }
              console.log('duplicate attachment name - try', name);
              break;
            }
          }
        }
        while (duplicate);
        console.log('deduped name', name);
        const i = event.target.result.indexOf(',');
        const type = event.target.result.substring(5, i - 7);
        this.$emit('add', { filename: name, data: event.target.result.substr(i + 1), type });
      };
      reader.readAsDataURL(fileToLoad);
    },
    onToolbarAction(action, tb) {
      this.$refs.button.onToolbarAction(action, tb);
    },
    onFileFocus() {
      this.disableTriggerHide = false;
    },
    onFileClick() {
      this.disableTriggerHide = true;
    }
  },
  computed: {
    attachmentOK() {
      return false;
    },
    fileInputLabel() {
      return this.$t('attachmentEditor.placeholder');
    },
    managedTriggerHide() {
      if (this.disableTriggerHide) {
        return false;
      } else {
        return this.triggerHide;
      }
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .wrap2 {
        width: 400px;
    }

    .input {
        display: grid;
        grid-template-columns: 369px 30px;
        grid-template-rows: 30px;
        grid-template-areas: "input input";
        overflow: hidden;
        .file {
            grid-area: input;
            width: 100%;
            label {
                width: 100%;
                display: inline-block;
                padding: 2px 5px;
                margin-bottom: 0;
                background-color: buttonface;
                border: 1px solid $gray-300;
                overflow: hidden;
                text-overflow: ellipsis;
                &:hover {
                    border: 1px solid $gray-500;
                }
            }
        }
    }

    .preview {
        .attachmentRow {
            display: grid;
            grid-template-columns: 30px 1fr 5em 30px;
            grid-template-areas: "icon name size delete";

            transition: background-color 0.2s;

            &.selected {
                background-color: $attachmenteditor-selectbg;
            }

            div {
                overflow: hidden;
                white-space: nowrap;
            }
            .name {
                grid-area: name;
                text-overflow: ellipsis;
            }
            .size {
                grid-area: size;
            }
            .delete {
                grid-area: delete;
            }
        }
    }

</style>
